/**
 * Domain-based branding configuration
 *
 * Default: Gruve branding (current behavior)
 * Only platform.sankalvax.ai shows SankalvaX branding
 */

/**
 * Check if current domain is SankalvaX
 * @returns {boolean}
 */
export const isSankalvaX = () => {
  return window.location.hostname === 'platform.sankalvax.ai';
};

/**
 * Get brand name
 * @returns {string} Brand name (SankalvaX or Gruve)
 */
export const getBrandName = () => {
  return isSankalvaX() ? 'SankalvaX' : 'Gruve';
};

/**
 * Get page title
 * @returns {string} Page title
 */
export const getPageTitle = () => {
  return isSankalvaX() ? 'SankalvaX Platform' : 'Gruve Platform';
};

export default {
  isSankalvaX,
  getBrandName,
  getPageTitle,
};
